import styled from "@emotion/styled"

export const MyHeadline = {
    block: styled.header`
        margin-bottom: 57px;

        @media (max-width: 1024px) and (min-width: 768px) {
            p,h2 {
                max-width: 75%;
            }
        }
    `,
    
    title: styled.h2`
        font-family: 'Shell Medium';
        line-height: 120%;
        color: #3B3B3B;
        font-size: 40px;
        margin: 0;
        font-weight: normal;
    `,
    
    text: styled.p`
        font-family: 'Shell Book';
        line-height: 160%;
        color: #3B3B3B;
        margin: 24px 0 0;
        font-size: 18px;
    `,
}